import type { Bill } from "@luckymenu/billing-core";
import { whatsappLink } from "@luckymenu/core";

/**
 * Sharing a bill (OP-14, P4-T21): the link to its public page
 * (`/b/<shareToken>`), copied on the web or given to the system share sheet
 * on Android, and a WhatsApp shortcut to the number on the bill when there
 * is one. `message` is the app's translated text with the link in it.
 */
export function billShare(
	bill: Pick<Bill, "shareUrl" | "customerPhone">,
	message: string,
): { url: string; text: string; whatsappUrl: string | null } {
	return {
		url: bill.shareUrl,
		text: message,
		whatsappUrl: bill.customerPhone ? whatsappLink(bill.customerPhone, message) : null,
	};
}
